var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-loadmore"},[_vm._m(0),_vm._t("default")],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"primary-loading"},[_c('span',{staticClass:"loading__dot"})])}]

export { render, staticRenderFns }